const findFirstFormError = (
  formErrorsObject: Record<string, any>,
  parentFieldPath = ''
): { fieldPath: string; errorMessage: string | undefined } | null => {
  for (const fieldName of Object.keys(formErrorsObject)) {
    const fieldErrorValue = formErrorsObject[fieldName];

    const fullFieldPath = parentFieldPath
      ? `${parentFieldPath}.${fieldName}`
      : fieldName;

    if (fieldErrorValue?.message) {
      return {
        fieldPath: fullFieldPath,
        errorMessage: fieldErrorValue.message
      };
    }

    if (typeof fieldErrorValue === 'object') {
      const nestedError = findFirstFormError(fieldErrorValue, fullFieldPath);
      if (nestedError) return nestedError;
    }
  }
  return null;
};

const getNestedProperty = (obj: any, pathSegments: string[]) => {
  return pathSegments.reduce(
    (acc, segment) =>
      acc && acc[segment] !== undefined ? acc[segment] : undefined,
    obj
  );
};

const setNestedProperty = (obj: any, pathSegments: string[], value: any) => {
  if (!obj || typeof obj !== 'object' || pathSegments.length === 0) {
    return obj;
  }

  const newObj = { ...obj };
  let current: any = newObj;

  for (let i = 0; i < pathSegments.length - 1; i++) {
    const segment = pathSegments[i];
    if (
      current[segment] === undefined ||
      typeof current[segment] !== 'object'
    ) {
      current[segment] = {};
    }
    current = current[segment];
  }

  current[pathSegments[pathSegments.length - 1]] = value;
  return newObj;
};

const addUniqueIdsToArrayItems = (formData: any, arrayFieldPaths: string[]) => {
  if (!formData || typeof formData !== 'object') {
    return formData;
  }

  let formDataWithUniqueIds = { ...formData };

  arrayFieldPaths.forEach((fieldPath) => {
    const pathSegments = fieldPath.split('.');
    const arrayToProcess = getNestedProperty(
      formDataWithUniqueIds,
      pathSegments
    );

    if (Array.isArray(arrayToProcess)) {
      const updatedArray = arrayToProcess.map((item: any) => ({
        ...item,
        id: item.id || Date.now() + Math.random()
      }));
      formDataWithUniqueIds = setNestedProperty(
        formDataWithUniqueIds,
        pathSegments,
        updatedArray
      );
    }
  });

  return formDataWithUniqueIds;
};

const formUtils = { findFirstFormError, addUniqueIdsToArrayItems };

export default formUtils;
